import React, {useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import {Grid, Popup, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {
  deleteClientManagement,
  deleteAdvisorManagement,
  deleteExemptionManagement,
  fetchAdvisorManagementList,
  fetchClientManagementList,
  fetchExemptionManagementList,
} = Actions;

const elementType = {
  'advisor': 'el asesor',
  'exemption': 'el rango de exoneración',
  'client': 'el cliente',
};

const DeleteIcon = ({code, dataType, dealerId, dealerRuc, disabled = false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  
  const handleOpen = () => {
    setIsOpen(true);
  };
  
  const handleClose = () => {
    setIsOpen(false);
  };
  
  const handleDeleteClick = async() => {
    if (dataType === 'advisor') {
      await dispatch(deleteAdvisorManagement(code, dealerId));
      dispatch(fetchAdvisorManagementList(dealerId));
    } else if (dataType === 'exemption') {
      await dispatch(deleteExemptionManagement(code));
      dispatch(fetchExemptionManagementList());
    } else if (dataType === 'client') {
      await dispatch(deleteClientManagement(code, dealerId, dealerRuc));
      dispatch(fetchClientManagementList(dealerId));
    }
    handleClose();
  };

  return (
    <Popup
      wide
      inverted
      on="click"
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      trigger={
        <span className="link">
          <i className="material-icons">
            delete
          </i>
        </span>
      }
    >
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <div>{`¿Desea eliminar ${elementType[dataType]}?`}</div>
            <Button secondary size="mini" onClick={handleClose}>
              CANCELAR
            </Button>
            <Button
              primary
              size="mini"
              onClick={handleDeleteClick}
              disabled={disabled}
            >
              ELIMINAR
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    'dealerId': state.session.dealerId,
  };
};

export default connect(mapStateToProps, {})(DeleteIcon);
